export const GET_ECOM_USERS_LIST = "GET_ECOM_USERS_LIST"
export const GET_ECOM_USERS_LIST_SUCCESS = "GET_ECOM_USERS_LIST_SUCCESS"
export const GET_ECOM_USERS_LIST_FAIL = "GET_ECOM_USERS_LIST_FAIL"
